/**
 * Defines the watchers related to Primary Navigation bar feature.
 * These watchers will be imported in store/RootSaga.js
 */

import { takeLatest, all } from 'redux-saga/effects';
import * as types from 'constants/ActionTypes';
import {
  getMFAConfigSaga, getUserDetailsSaga, getGuestUserDetailsSaga, getLoadersSaga, pollUnreadMsgs,
  emitFullscreenSaga, fetchSharedAppConfigSaga, syncEvoneBannerVisibilitySaga,
} from './SideBar.saga';

export default function* watchers() {
  yield all([
    yield takeLatest(
      [
        types.FETCH_USER_ENTITLED_APPS_SUCCESS,
        types.FETCH_USER_ENTITLED_APPS_ERROR,
        types.SET_EVONE_LD_SHOW_BANNER,
      ],
      syncEvoneBannerVisibilitySaga,
    ),
    yield takeLatest(types.MFA_CONFIG_REQUESTED, getMFAConfigSaga),
    yield takeLatest(types.USER_DETAILS_REQUESTED, getUserDetailsSaga),
    yield takeLatest(types.LOADERS_REQUESTED, getLoadersSaga),
    yield takeLatest(types.NOTIFICATIONS_POLL, pollUnreadMsgs),
    yield takeLatest([types.TOGGLE_SIDEBAR_SHOW, types.TOGGLE_SIDEBAR_HIDE, types.SET_FULL_SCREEN], emitFullscreenSaga),
    yield takeLatest(types.FETCH_SHARED_APP_CONFIG, fetchSharedAppConfigSaga),
    yield takeLatest(types.GUEST_USER_DETAILS_REQUESTED, getGuestUserDetailsSaga),
  ]);
}
